module.exports = __webpack_public_path__ + "static/img/add-safety-image.cefad0ea.svg";